var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsCrowdenergy268(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 99.2 99.2",
    style: {
      enableBackground: "new 0 0 99.2 99.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "podklad"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFAF00",
    d: "M89.6,4c3.1,0,5.6,2.5,5.6,5.6v80c0,3.1-2.5,5.6-5.6,5.6h-80c-3.1,0-5.6-2.5-5.6-5.6v-80C4,6.5,6.5,4,9.6,4 H89.6 M89.6,0h-80C4.3,0,0,4.3,0,9.6v80c0,5.3,4.3,9.6,9.6,9.6h80c5.3,0,9.6-4.3,9.6-9.6v-80C99.2,4.3,94.9,0,89.6,0L89.6,0z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "svg5673"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "path6255_3_",
    fill: "none",
    stroke: "#FFAF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 49.6,
    cy: 50.3,
    rx: 23.1,
    ry: 22.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6255_14_",
    fill: "none",
    stroke: "#FFAF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M35.4,50.3c0-1,0.1-2,0.3-2.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6255_12_",
    fill: "none",
    stroke: "#FFAF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M41.3,61.7c-0.9-0.6-1.4-1-2.1-1.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6255_15_",
    fill: "none",
    stroke: "#FFAF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M59.6,60.2c-0.9,0.9-1.7,1.6-2.9,2.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6255_13_",
    fill: "none",
    stroke: "#FFAF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M63.5,47.2c0.2,1,0.3,2,0.3,3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6255_10_",
    fill: "none",
    stroke: "#FFAF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M47.1,36.5c0.9-0.2,1.5-0.3,2.5-0.3c0.9,0,1.8,0.1,2.7,0.3"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "path6267_3_",
    fill: "none",
    stroke: "#FFAF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 39.7,
    cy: 39.9,
    rx: 8.2,
    ry: 8.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "path6267_9_",
    fill: "none",
    stroke: "#FFAF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 39.7,
    cy: 39.9,
    rx: 2.5,
    ry: 2.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "path6267_10_",
    fill: "none",
    stroke: "#FFAF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 59.7,
    cy: 39.9,
    rx: 8.2,
    ry: 8.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "path6267_8_",
    fill: "none",
    stroke: "#FFAF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 59.7,
    cy: 39.9,
    rx: 2.5,
    ry: 2.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "path6267_12_",
    fill: "none",
    stroke: "#FFAF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 49,
    cy: 65,
    rx: 8.2,
    ry: 8.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "path6267_11_",
    fill: "none",
    stroke: "#FFAF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 49,
    cy: 65,
    rx: 2.5,
    ry: 2.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "path6267_14_",
    fill: "none",
    stroke: "#FFAF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 64.2,
    cy: 56.4,
    rx: 6.1,
    ry: 6.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "path6267_13_",
    fill: "none",
    stroke: "#FFAF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 64.2,
    cy: 56.4,
    rx: 0.5,
    ry: 0.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "path6267_16_",
    fill: "none",
    stroke: "#FFAF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 34.3,
    cy: 56.4,
    rx: 6.1,
    ry: 6.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "path6267_15_",
    fill: "none",
    stroke: "#FFAF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 34.3,
    cy: 56.4,
    rx: 0.5,
    ry: 0.5
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFAF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M85,50.3c0-19.3-15.8-35-35.3-35c-19.5,0-35.3,15.7-35.3,35c0,15.4,10.1,28.5,24.1,33.2v3.3 c0,2.6,2.1,4.7,4.7,4.7h13.1c2.6,0,4.7-2.1,4.7-4.7v-3.3C74.9,78.8,85,65.7,85,50.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFAF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M81.6,50.3c0-17.5-14.3-31.7-32-31.7c-17.7,0-32,14.2-32,31.7c0,15.1,10.6,27.7,24.8,30.9v4.5 c0,1.1,0.9,1.9,1.9,1.9H55c1.1,0,1.9-0.9,1.9-1.9v-4.5C71.1,77.9,81.6,65.3,81.6,50.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#FFAF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: "40.8,15.7 42.2,7.8 44.7,7.8 44.7,15.1  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#FFAF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: "58.4,15.7 57,7.8 54.5,7.8 54.5,15.1  "
  })), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFAF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 44.7,
    y1: 8.8,
    x2: 54.5,
    y2: 8.8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsCrowdenergy268);
export default __webpack_public_path__ + "static/media/icons-crowdenergy-268.0f5aa50d91018411ab087e8a5c9310c4.svg";
export { ForwardRef as ReactComponent };